export enum ClientErrorSource {
    ErrorBoundary = 1,
    WindowOnError = 2,
    UnhandledRejection = 3,
    BlankScreenWatchdog = 4,
    ClubhouseFetchFailure = 5,
}

export const ClientErrorSourceLabels = [
    { id: ClientErrorSource.ErrorBoundary, name: 'Error Boundary' },
    { id: ClientErrorSource.WindowOnError, name: 'Window Error' },
    { id: ClientErrorSource.UnhandledRejection, name: 'Unhandled Rejection' },
    { id: ClientErrorSource.BlankScreenWatchdog, name: 'Blank Screen Watchdog' },
    { id: ClientErrorSource.ClubhouseFetchFailure, name: 'Clubhouse Fetch Failure' },
];
